<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      edit-title
      title="晚休未考勤明细"
      id-key="StayRegId"
      :data="data"
      form-label-width="90px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @details-opened="onDetailsOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-table border :data="tableData" size="small">
              <el-table-column prop="DormitoryNumber" label="宿舍号">
                <template slot-scope="{row}">
                  {{row.DormitoryAddr + row.DormitoryNumber}}
                </template>
              </el-table-column>
              <el-table-column prop="FullName" label="姓名"/>
              <el-table-column prop="ClassNo" label="班级"/>
            </el-table>
          </el-col>
        </el-row>
      </template>
      <template #footer>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require("@/api/at/attendance").default,
      data: {
        
      },
      tableData: [],
      isMB: this.$store.state.isMB,
      rules: {
        
      },
    };
  },
  methods: {
    onDetailsOpened(data) {
      this.loading(true);
      this.api.getNightAttendanceStudentList({ AttendanceDate: data.AttendanceDate }).then(res => {
        this.loading(false);
        if(res.Code==0) {
          this.tableData = res.Data;
        } else {
          this.$message.error(res.Msg);
        }
      })
    },
    onClosed() {
      this.tableData = [];
    },
  },
};
</script>